import { render } from "./DesignerCollectionItem.vue?vue&type=template&id=b6608460"
import script from "./DesignerCollectionItem.vue?vue&type=script&lang=js"
export * from "./DesignerCollectionItem.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__